import {
  CONTACT_CREATE_REQUEST,
  CONTACT_CREATE_SUCCESS,
  CONTACT_CREATE_FAIL,
  CONTACT_LIST_REQUEST,
  CONTACT_LIST_SUCCESS,
  CONTACT_LIST_FAIL,
  CONTACT_CREATE_RESET,
  CONTACT_CREATE_REQUEST2,
  CONTACT_CREATE_SUCCESS2,
  CONTACT_CREATE_RESET2,
  CONTACT_CREATE_FAIL2,
  CONTACT_DETAILS_REQUEST,
  CONTACT_DETAILS_SUCCESS,
  CONTACT_DETAILS_FAIL,
  CONTACT_DETAILS_RESET,
} from "../constants/contactConstants";

export const createContactReducer = (state = { contact: {} }, action) => {
  switch (action.type) {
    case CONTACT_CREATE_REQUEST:
      return { loading: true };
    case CONTACT_CREATE_SUCCESS:
      return { loading: false, success: true, contact: action.payload };
    case CONTACT_CREATE_FAIL:
      return { loading: false, error: action.payload };
    case CONTACT_CREATE_RESET:
      return { contact: {} };
    default:
      return state;
  }
};

export const createContactReducer2 = (state = { contact: {} }, action) => {
  switch (action.type) {
    case CONTACT_CREATE_REQUEST2:
      return { loading: true };
    case CONTACT_CREATE_SUCCESS2:
      return { loading: false, success: true, contact: action.payload };
    case CONTACT_CREATE_FAIL2:
      return { loading: false, error: action.payload };
    case CONTACT_CREATE_RESET2:
      return { contact: {} };
    default:
      return state;
  }
};

export const contactDetailsReducer = (state = { contact: {} }, action) => {
  switch (action.type) {
    case CONTACT_DETAILS_REQUEST:
      return { loading: true };
    case CONTACT_DETAILS_SUCCESS:
      return { loading: false, success: true, contactDet: action.payload };
    case CONTACT_DETAILS_FAIL:
      return { loading: false, error: action.payload };
    case CONTACT_DETAILS_RESET:
      return { contact: {} };
    default:
      return state;
  }
};

export const contactListReducer = (state = { contacts: [] }, action) => {
  switch (action.type) {
    case CONTACT_LIST_REQUEST:
      return { loading: true };
    case CONTACT_LIST_SUCCESS:
      return { loading: false, contacts: action.payload };
    case CONTACT_LIST_FAIL:
      return { loading: false, error: action.payload };
    case CONTACT_CREATE_RESET:
      return { contacts: [] };
    default:
      return state;
  }
};
